import React, { useEffect, useState } from 'react';
import { Modal, Input, message } from 'antd';
import { smsApi } from '../../utils/api';

const { TextArea } = Input;

const SendSmsModal = ({ open, type, recordId, recipientName, onClose, onSuccess }) => {
  const [messageText, setMessageText] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) {
      setMessageText('');
    }
  }, [open, recordId]);

  const handleSend = async () => {
    const trimmed = messageText.trim();
    if (!trimmed) {
      message.warning('لطفاً متن پیامک را وارد کنید');
      return;
    }
    if (!recordId) {
      message.error('شناسه رکورد یافت نشد');
      return;
    }

    setSending(true);
    try {
      await smsApi.send({ type, id: Number(recordId), message: trimmed });
      message.success('پیامک با موفقیت ارسال شد');
      onSuccess?.();
      onClose?.();
    } catch (error) {
      message.error(error?.message || 'خطا در ارسال پیامک');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      title="ارسال پیامک"
      open={open}
      onCancel={onClose}
      onOk={handleSend}
      okText="ارسال"
      cancelText="انصراف"
      confirmLoading={sending}
      destroyOnClose
      width={480}
      okButtonProps={{ className: 'bg-green-600 hover:bg-green-700 border-0' }}
    >
      <div className="space-y-4" style={{ fontFamily: 'CustomFont' }}>
        {recipientName && (
          <p className="text-sm text-gray-500 dark:text-gray-400 m-0">
            گیرنده: <span className="font-medium text-gray-800 dark:text-gray-200">{recipientName}</span>
          </p>
        )}
        <TextArea
          rows={5}
          value={messageText}
          onChange={(e) => setMessageText(e.target.value)}
          placeholder="متن پیامک را بنویسید..."
          maxLength={500}
          showCount
          style={{ fontFamily: 'CustomFont' }}
        />
      </div>
    </Modal>
  );
};

export default SendSmsModal;
